import React, { useState } from 'react';
import { t as uiText } from '../../../i18n';
import { useEmailVerification } from '../EmailVerificationContext';
import ResendButton from './ResendButton';
import ChangeEmailButton from './ChangeEmailButton';
import EmailHelp from './EmailHelp';

/**
 * 初回案内モーダル（2段階）。
 * - 案内の表示済み記録（noticeAcked）はアカウント単位でサーバーに保存する
 * - emailVerified や利用制限の解除条件には使わない
 */
const EmailVerificationModals: React.FC = () => {
  const { phase, email, noticeAcked, acknowledgeNotice, showPublicRag } = useEmailVerification();
  const [step, setStep] = useState<1 | 2>(1);

  // 72時間経過後はロック画面を優先し、案内モーダルは出さない
  if ((phase !== 'A' && phase !== 'B') || noticeAcked) return null;

  if (step === 1) {
    return (
      <div className="ev-overlay" role="presentation">
        <div className="ev-dialog" role="dialog" aria-modal="true" aria-labelledby="ev-modal1-title">
          <h2 id="ev-modal1-title" className="ev-title">
            {uiText('Please check your email address')}
          </h2>
          <p>{uiText('We sent a confirmation email to the address you registered.')}</p>
          <p>{uiText('Please complete verification using the link in the email.')}</p>
          {email && (
            <p className="ev-email">
              <strong>{email}</strong>
            </p>
          )}
          <div className="ev-actions ev-actions-stack">
            <button type="button" className="ev-btn ev-btn-primary" autoFocus onClick={() => setStep(2)}>
              OK
            </button>
            <ResendButton />
            <ChangeEmailButton />
          </div>
          <EmailHelp />
        </div>
      </div>
    );
  }

  return (
    <div className="ev-overlay" role="presentation">
      <div className="ev-dialog" role="dialog" aria-modal="true" aria-labelledby="ev-modal2-title">
        <h2 id="ev-modal2-title" className="ev-title">
          {uiText('About usage limits if email verification is not completed')}
        </h2>
        <p>{uiText('Please complete email verification within 72 hours of creating your account.')}</p>
        <p>
          {showPublicRag
            ? uiText(
                'If your email is still unverified after 72 hours, notreu features and the public RAG installed on your website may become unavailable.'
              )
            : uiText('If your email is still unverified after 72 hours, notreu features may become unavailable.')}
        </p>
        {showPublicRag && (
          <p>{uiText('This also affects visitors to your site, so please complete verification before the deadline.')}</p>
        )}
        <div className="ev-actions">
          <button
            type="button"
            className="ev-btn ev-btn-primary"
            autoFocus
            onClick={() => {
              void acknowledgeNotice();
            }}
          >
            {uiText('I understand')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationModals;
